const getSpinnerStatus = (rootState) => rootState.spinner;

export default getSpinnerStatus;
